import { gql } from "@apollo/client"

export const DELETE_PAYMENT_CREDENTIAL = gql`
  mutation($id: String!, $storeId: String!) {
    deletePaymentCredentials(id: $id, restaurantId: $storeId) {
      id
    }
  }
`
